import React from 'react';
import { Box, Container, Grid } from '@mui/material';
import Intro from '../Components/Typography/Intro';
import IndexNumber from '../Components/Typography/IndexNumber';
import Outro from '../Components/Typography/Outro';
import ContentWrapper from '../Components/ContentWrapper';
import { EarlyWrapper } from '../Components/animation/EarlyWrapper';
import { DelayedWrapper } from '../Components/animation/DelayedWrapper';

const About = () => {
  return (
    <ContentWrapper>
      <Container maxWidth='xxl'>
        <Grid container spacing={2}>
          {/* -----Number------- */}
          <Grid item xs={12} md={2} xl={2} xxl={2}>
            <EarlyWrapper>
              <IndexNumber number='01 /' />
            </EarlyWrapper>
          </Grid>
          {/* --------- Intro ----------- */}
          <Grid item xs={12} md={10} xl={10} xxl={10}>
            <Intro />
            <Box textAlign='center'>
              <DelayedWrapper>
                <Outro />
              </DelayedWrapper>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </ContentWrapper>
  );
};

export default About;
